import { Injectable } from '@angular/core';
import { RegisteredRetailer } from '../models/registered-retailer.model';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RetailerDataStoreService {
  private retailer: RegisteredRetailer | null = null;
  private capturedImageFile: File | null = null;
  private navigateToLandingPage: boolean = false;

  private dealerDataRefreshSource = new Subject<boolean>();
  dealerDataRefresh$ = this.dealerDataRefreshSource.asObservable();

  constructor() { }

  getNavigateToLandingPage(): boolean {
    return this.navigateToLandingPage;
  }

  setNavigateToLandingPage(value: boolean): void {
    this.clearRetailer();
    this.navigateToLandingPage = value;
  }

  setRetailer(retailer: RegisteredRetailer | null): void {
    this.retailer = retailer;
    this.navigateToLandingPage = false;
  }

  getRetailer(): RegisteredRetailer | null {
    return this.retailer;
  }

  clearRetailer(): void {
    this.retailer = null;
  }

  setCapturedImageFile(file: File | null): void {
    this.capturedImageFile = file;
  }

  getCapturedImageFile(): File | null {
    return this.capturedImageFile;
  }

  clearCapturedImageFile(): void {
    this.capturedImageFile = null;
  }

  triggerDealerDataRefresh() {
    this.dealerDataRefreshSource.next(true);
  }
}